import { useLocalStorage } from '@vueuse/core'

export const useUserPreferences = () => {
  return useLocalStorage('userPreferences', {
    fontSize: 1,
    primarySidebar: true,
    secondarySidebar: true,
  })
}
